import { X } from "lucide-react";

import background from "../../assets/images/bookDemo/background.png";
import SlideInAnimation from "../../components/animation/SlideInAnimation";
import Touchable from "../../components/ui/Touchable";
import useStore from "../../hooks/store/useStore";
import { EventTrackingSourcePageType } from "../../services/EventTracking/types";
import { SourceType } from "../../types";

import ThanksModel from "./components/ThanksModel";
import BookDemoFormHK from "./BookDemoFormHK";
import BookDemoFormOthers from "./BookDemoFormOthers";
import BookDemoIntroJP from "./BookDemoIntroJP";

export default function BookDemoDrawer({
  sourcePage,
}: {
  sourcePage: EventTrackingSourcePageType;
}) {
  const { source } = useStore((state) => state.global);
  const { userInformation } = useStore((state) => state.user);
  const { showBookDemoDrawer, setShowBookDemoDrawer, showBookDemoThanks } =
    useStore((state) => state.bookDemo);

  const { trialUserSegmentation: seg, market } = userInformation || {};

  if (source === SourceType.ClubApp && (seg === "Decision" || seg === "Action"))
    return null;

  return (
    <>
      <SlideInAnimation
        underlay
        isVisible={showBookDemoDrawer}
        className="fixed bottom-0 left-0 flex max-h-screen w-full flex-col rounded-t-3xl bg-pink1 pt-3"
      >
        <img
          src={background}
          alt="background"
          className="absolute left-0 top-8 w-full"
        />

        <div className="relative z-10 max-h-[calc(100dvh-12px)]">
          <div className="flex h-11 w-full flex-row-reverse">
            <Touchable onClick={() => setShowBookDemoDrawer(false)}>
              <X className="text-orange2 mx-4 my-2.5 size-6" />
            </Touchable>
          </div>

          {/* 56px: header's height */}
          <div className="custom-scrollbar relative z-10 max-h-[calc(100dvh-56px)] flex-grow overflow-y-scroll">
            {market === "HK" ? (
              <BookDemoFormHK />
            ) : market === "JP" ? (
              <BookDemoIntroJP sourcePage={sourcePage} />
            ) : (
              <BookDemoFormOthers />
            )}
          </div>
        </div>
      </SlideInAnimation>

      {showBookDemoThanks ? <ThanksModel /> : null}
    </>
  );
}
